<div class="inbox-container">

  <!-- Header -->
  <div class="inbox-header">
    <h2 class="inbox-title">
      <mat-icon class="inbox-icon">notifications</mat-icon>
      Benachrichtigungen
      <span class="unread-chip" *ngIf="unreadCount > 0">{{ unreadCount }} ungelesen</span>
    </h2>
    <button
      mat-stroked-button
      *ngIf="unreadCount > 0"
      (click)="markAllRead()"
      class="mark-all-btn"
    >
      Alle als gelesen markieren
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && notifications.length === 0" class="empty-state">
    <mat-icon class="empty-icon">notifications_none</mat-icon>
    <p>Keine Benachrichtigungen vorhanden</p>
  </div>

  <!-- Notification list -->
  <mat-list *ngIf="!isLoading && notifications.length > 0" class="notification-list">
    <mat-list-item
      *ngFor="let notification of notifications"
      class="notification-item"
      [class.unread]="!notification.read"
      (click)="openNotification(notification)"
    >
      <div class="item-content">
        <div class="item-left">
          <span class="unread-dot" *ngIf="!notification.read"></span>
          <mat-icon class="item-icon" [class.icon-unread]="!notification.read">notifications</mat-icon>
        </div>
        <div class="item-body">
          <div class="item-title" [class.bold]="!notification.read">{{ notification.title }}</div>
          <div class="item-preview">{{ notification.body }}</div>
          <div class="item-time">{{ formatTimestamp(notification) }}</div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>

  <!-- Detail overlay -->
  <div class="detail-overlay" *ngIf="selectedNotification" (click)="closeDetail()">
    <mat-card class="detail-card" (click)="$event.stopPropagation()">
      <mat-card-header>
        <mat-icon mat-card-avatar>notifications</mat-icon>
        <mat-card-title>{{ selectedNotification.title }}</mat-card-title>
        <mat-card-subtitle>{{ formatTimestamp(selectedNotification) }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p class="detail-body">{{ selectedNotification.body }}</p>
        <p class="detail-message" *ngIf="selectedNotification.messageBody">
          {{ selectedNotification.messageBody }}
        </p>
        <p class="detail-sender" *ngIf="selectedNotification.senderName">
          <mat-icon style="font-size: 14px; vertical-align: middle">person</mat-icon>
          {{ selectedNotification.senderName }}
        </p>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-stroked-button (click)="closeDetail()">Schließen</button>
      </mat-card-actions>
    </mat-card>
  </div>

</div>
